import megatron from 'megatron';

export const getSRPData = ({url}) => {
    const headers = {
      
    };
    const type = 'GET';
    const credentials = 'include';
    return megatron({
        url,
        name,
        type,
        headers,
        credentials
    });
}
